import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AppParamsService } from './services/app-params.service';
import { LeadService } from './services/lead.service';
import { Observable } from 'rxjs';
import { LoadingService } from './services/loading.service';


declare let TrackJS: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'MoneyMarketFront';

  isLoading$: Observable<boolean>;


  constructor(
    private aRoute: ActivatedRoute,
    private appParamsService: AppParamsService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: any,
    private leadService: LeadService,
    private loadingService: LoadingService
  ) {
    this.isLoading$ = this.loadingService.loading$;
  }

  async ngOnInit() {
    //localStorage.removeItem('lead');


    this.router.events.subscribe(event => {


      if (event instanceof NavigationEnd && this.router.navigated) {
        //console.error('event', event);
        this.aRoute.queryParams
          .subscribe(async (res: any) => {

            if (res['return_days_radio']) {
              console.error('params', res);
              console.error('entry_url', window.location.href);
              console.error('URL return days invalid');
              console.error('params saved', this.appParamsService.getParams())
              console.error('data', this.leadService.getLead());
            }

            // check origin affrefcidorigin and affiliatereferenceid
            var params: any = { ...res };

            if (!params.hasOwnProperty('AffRefCidOrigin') && !params.hasOwnProperty('affRefCidOrigin')) {
              params['AffRefCidOrigin'] = environment.cid;
            }

            if (!params.hasOwnProperty('AffiliateReferenceID') || params['AffiliateReferenceID'] === '') {
              params['AffiliateReferenceID'] = params['sub_id'] ? params['sub_id'] : 'organic';
            }


            await this.appParamsService.setParams(params);

            if (isPlatformBrowser(this.platformId)) {
              this.appParamsService.setEntryUrl(window.location.href);

              // set metadata to trackJS
              if (TrackJS) {
                let mappedParams: any = this.appParamsService.getParams();
                TrackJS.addMetadata('sub_id', params.sub_id || 'organic');
                TrackJS.addMetadata('entry_url', this.appParamsService.getEntryUrl());
                TrackJS.track(`Params: ${JSON.stringify(mappedParams)}`);
                for (const key in mappedParams) {
                  if (key !== 'additionalParams') {
                    TrackJS.addMetadata(key, mappedParams[key]);
                  } else {
                    let additionalParams = mappedParams[key];
                  }
                }

                console.log('TrackJS OK!');
              }

            }
          });
      }
    });


  }


}
